import type { ViewIds } from '@ardoq/api-types';
import { DropdownOptionType } from '@ardoq/dropdown-menu';
import { DropdownSize } from '@ardoq/dropdown-menu-ui';
import { IconName } from '@ardoq/icons';
import { t, type I18nLocale } from '@ardoq/i18n';
import { SettingsType, type SettingsConfig } from '@ardoq/view-settings';
import type { RadialMarkType } from '@ardoq/xyz-charts';
import { handleStoreSetting } from 'viewSettings/settingsHelper';

const MARK_TYPE_OPTIONS: [RadialMarkType, string, string][] = [
  ['line', 'Line', 'views:radialCharts.markType.line'],
  ['area', 'Area', 'views:radialCharts.markType.area'],
  ['spline', 'Spline', 'views:radialCharts.markType.spline'],
  ['splineArea', 'Spline area', 'views:radialCharts.markType.splineArea'],
];

export type MarkTypeDropdownArgs = {
  viewId: ViewIds;
  id: string;
  markType: RadialMarkType;
  i18nLocale: I18nLocale;
};

export const markTypeDropdown = ({
  viewId,
  id,
  markType,
  i18nLocale,
}: MarkTypeDropdownArgs): SettingsConfig => ({
  id,
  type: SettingsType.DROPDOWN,
  iconName: IconName.LINE_CHART,
  label: t(i18nLocale, 'views:radialCharts.markType.label', 'Mark type'),
  options: MARK_TYPE_OPTIONS.map(([option, label, i18nKey]) => ({
    name: `${id}_${option}`,
    label: t(i18nLocale, i18nKey, label),
    type: DropdownOptionType.OPTION,
    isActive: markType === option,
    onClick: () => handleStoreSetting(viewId, { markType: option }),
  })),
  dropdownSize: DropdownSize.S,
});
